import { defineStore } from 'pinia';
import axios from 'axios';

// Subscription dashboard widgets + reports (Features 9 & 14).
export const useSubscriptionReportStore = defineStore('subscriptionReports', {
    state: () => ({
        dashboard: null,
        reports: null,
        loadingDashboard: false,
        loadingReports: false,
    }),

    actions: {
        async fetchDashboard() {
            this.loadingDashboard = true;
            try {
                const { data } = await axios.get('/admin/subscriptions/dashboard');
                this.dashboard = data.data;
            } finally {
                this.loadingDashboard = false;
            }
        },

        async fetchReports() {
            this.loadingReports = true;
            try {
                const { data } = await axios.get('/admin/subscriptions/reports');
                this.reports = data.data;
            } finally {
                this.loadingReports = false;
            }
        },
    },
});
